import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Plus, Pencil, Trash2, X, Save } from 'lucide-react';

export default function FormasEntrega() {
  const [formas, setFormas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ nome: '', is_ativo: true });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = () => api.get('/configuracoes/formas-entrega').then(r => setFormas(r.data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ nome: '', is_ativo: true }); setEditId(null); setShowForm(true); setError(''); };
  const openEdit = (f) => { setForm({ nome: f.nome, is_ativo: f.is_ativo }); setEditId(f.id); setShowForm(true); setError(''); };

  const handleSave = async () => {
    if (!form.nome.trim()) { setError('Nome é obrigatório'); return; }
    setSaving(true);
    try {
      if (editId) await api.put(`/configuracoes/formas-entrega/${editId}`, form);
      else await api.post('/configuracoes/formas-entrega', form);
      setShowForm(false);
      setLoading(true);
      load();
    } catch (err) { setError(err.userMessage || 'Erro ao salvar'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir esta forma de entrega?')) return;
    try {
      await api.delete(`/configuracoes/formas-entrega/${id}`);
      setFormas(fs => fs.filter(f => f.id !== id));
    } catch (err) { alert(err.userMessage || 'Erro ao excluir'); }
  };

  const inputCls = "w-full rounded-lg border border-brand-border px-3 py-2 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid";

  return (
    <div data-testid="formas-entrega">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="dashboard-heading text-2xl">Formas de Entrega</h1>
          <p className="text-brand-text-muted font-body text-sm">Opções disponíveis no cadastro de Rotas</p>
        </div>
        <button onClick={openNew} className="flex items-center gap-2 py-2 px-4 rounded-lg btn-primary font-dashboard font-semibold text-sm" data-testid="new-forma-btn">
          <Plus className="w-4 h-4" /> Nova Forma
        </button>
      </div>

      {showForm && (
        <div className="card-dashboard mb-4 max-w-md">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-dashboard font-semibold text-brand-text">{editId ? 'Editar' : 'Nova'} Forma de Entrega</h3>
            <button onClick={() => setShowForm(false)}><X className="w-4 h-4 text-brand-text-muted" /></button>
          </div>
          {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
          <div className="space-y-3">
            <div>
              <label className="block text-xs text-brand-text-muted mb-1 font-body">Nome *</label>
              <input
                className={inputCls}
                value={form.nome}
                onChange={e => setForm(f => ({ ...f, nome: e.target.value }))}
                placeholder="Ex: Retirada, Próprio, Delivery..."
                data-testid="field-nome-forma"
              />
            </div>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={form.is_ativo} onChange={e => setForm(f => ({ ...f, is_ativo: e.target.checked }))} />
              <span className="text-sm font-body text-brand-text">Ativo</span>
            </label>
            <button onClick={handleSave} disabled={saving} className="flex items-center gap-2 px-4 py-2.5 rounded-lg btn-primary font-dashboard font-semibold text-sm" data-testid="save-forma-btn">
              <Save className="w-4 h-4" /> {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      <div className="card-dashboard">
        {loading ? (
          <div className="flex justify-center py-12"><div className="w-6 h-6 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" /></div>
        ) : formas.length === 0 ? (
          <p className="text-center text-brand-text-muted text-sm py-12 font-body">Nenhuma forma cadastrada</p>
        ) : (
          <table className="w-full text-sm font-body">
            <thead>
              <tr className="border-b border-brand-border bg-brand-bg">
                <th className="text-left py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Nome</th>
                <th className="text-center py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Status</th>
                <th className="py-2.5 px-3"></th>
              </tr>
            </thead>
            <tbody>
              {formas.map(f => (
                <tr key={f.id} className="border-b border-brand-border last:border-0 hover:bg-brand-bg/50" data-testid="forma-row">
                  <td className="py-2.5 px-3 font-medium text-brand-text">{f.nome}</td>
                  <td className="py-2.5 px-3 text-center">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${f.is_ativo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {f.is_ativo ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td className="py-2.5 px-3">
                    <div className="flex gap-2 justify-end">
                      <button onClick={() => openEdit(f)} className="p-1.5 rounded hover:bg-brand-bg" data-testid="edit-forma-btn"><Pencil className="w-3.5 h-3.5 text-brand-text-muted" /></button>
                      <button onClick={() => handleDelete(f.id)} className="p-1.5 rounded hover:bg-red-50" data-testid="delete-forma-btn"><Trash2 className="w-3.5 h-3.5 text-red-500" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
